module.exports = class BrowserHistoryHandler
  popCallbacks: []

  constructor: (@id) ->
    return unless window.history?.pushState?

    $(window).on 'popstate', ({ originalEvent }) =>
      state = originalEvent?.state
      data = if state?.mppHistory?.id is @id then state.mppHistory.data else {}
      @triggerPop data

  onPop: (cb) ->
    @popCallbacks.push cb

  triggerPop: (data) ->
    cb(data) for cb in @popCallbacks

  add: (data) ->
    return unless window.history?.pushState?
    url = window.location.href.replace /#.+$/, ''
    mppHistory = { id: @id, data: data }
    history.pushState { mppHistory }, document.title, url
